import React, { lazy, memo } from 'react';
const Testimonials = memo(() => {
  return <section className="py-16 bg-white" data-id="element-286">
      <div className="container mx-auto px-4" data-id="element-287">
        <div className="text-center mb-12" data-id="element-288">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800" data-id="element-289">
            Lo que dicen quienes ya lo están usando
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-290">
            Historias reales de personas como tú que han transformado sus cenas
            diarias
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-291">
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-292">
            <div className="flex items-center mb-4" data-id="element-293">
              <div className="img-container aspect-ratio-1-1 w-16 h-16 rounded-full overflow-hidden mr-4" data-id="element-294">
                <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Claudia R." className="img-content" width="64" height="64" loading="lazy" decoding="async" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://via.placeholder.com/64x64/f5f5f5/a97142?text=CR';
              }} data-id="element-295" />
              </div>
              <div data-id="element-296">
                <h4 className="font-bold text-lg" data-id="element-297">Claudia R.</h4>
                <p className="text-gray-600" data-id="element-298">Medellín, Colombia</p>
              </div>
            </div>
            <div className="text-amber-500 mb-2" data-id="element-299">⭐⭐⭐⭐⭐</div>
            <p className="text-gray-700 italic" data-id="element-300">
              "Ahora en 30 minutos cenamos rico y hasta nos sobra tiempo para
              ver una peli juntos. Antes pasaba horas en la cocina o
              terminábamos pidiendo comida."
            </p>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg" data-id="element-301">
            <div className="flex items-center mb-4" data-id="element-302">
              <div className="img-container aspect-ratio-1-1 w-16 h-16 rounded-full overflow-hidden mr-4" data-id="element-303">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="José M." className="img-content" width="64" height="64" loading="lazy" decoding="async" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://via.placeholder.com/64x64/f5f5f5/a97142?text=JM';
              }} data-id="element-304" />
              </div>
              <div data-id="element-305">
                <h4 className="font-bold text-lg" data-id="element-306">José M.</h4>
                <p className="text-gray-600" data-id="element-307">Houston, TX</p>
              </div>
            </div>
            <div className="text-amber-500 mb-2" data-id="element-308">⭐⭐⭐⭐⭐</div>
            <p className="text-gray-700 italic" data-id="element-309">
              "Antes pedía pizza cada semana, ahora gasto menos y comemos más
              sano. Mi esposa no puede creer que yo haya cocinado estas recetas
              tan ricas."
            </p>
          </div>
        </div>
      </div>
    </section>;
});
export default Testimonials;